export default __webpack_public_path__ + "static/2-7cf1ae1d5238b93f2857e211e2ba2749.jpeg";